import * as React from 'react';
import Base, { Props as BaseProps } from '../Base/Base';
import './Logo.css';

export interface Props extends BaseProps {
  /**
   * Sets the height of the logo. Note to keep correct proportions
   * correct, if height is supplied the width should be omitted and
   * it will be derived from the height.
   * */
  height?: number;
  /**
   * Sets the width of the logo. Note to keep correct proportions
   * correct, if width is supplied the height should be omitted and
   * it will be derived from the width.
   * */
  width?: number;
}

const viewBoxHeight = 29;
const viewBoxWidth = 35;
const viewBox = `0 0 ${viewBoxWidth} ${viewBoxHeight}`;
const viewBoxScale = viewBoxWidth / viewBoxHeight;


/**
 * Bitrise Logo
 */
const Logo: React.FunctionComponent<Props> = (props: Props) => {
  const { height, width } = props;
  const scaledHeight = width ? width / viewBoxScale : height;
  const scaledWidth = height ? height * viewBoxScale : width;

  return (
    <Base
        Component="svg"
        className="Logo"
        height={ scaledHeight }
        viewBox={ viewBox }
        width={ scaledWidth }
        xmlns="http://www.w3.org/2000/svg">
      <g fill="currentColor" fillRule="evenodd">
        <path d="M17.103 22.771a3.804 3.804 0 0 1-3.803-3.804h7.607c0 2.101-1.703 3.804-3.804 3.804zM8.602 14.27a2.349 2.349 0 0 0-2.349 2.349h4.697a2.349 2.349 0 0 0-2.348-2.349M25.622 14.27a2.349 2.349 0 0 0-2.349 2.35h4.697a2.349 2.349 0 0 0-2.348-2.35M17.103 3.08a1.455 1.455 0 1 0 0-2.91 1.455 1.455 0 0 0 0 2.91"></path>
        <path d="M31.19 24.734a2.615 2.615 0 0 1-1.84.876c-2.937.137-7.444.301-12.247.301-4.802 0-9.31-.164-12.245-.3a2.615 2.615 0 0 1-1.842-.877 2.607 2.607 0 0 1-.661-1.922c.154-2.349.364-4.428.622-6.18.383-2.6.959-5.24 1.374-6.997a2.611 2.611 0 0 1 2.393-2.017c2.129-.133 5.654-.29 10.36-.29 4.704 0 8.23.157 10.36.29a2.611 2.611 0 0 1 2.392 2.017c.416 1.757.991 4.398 1.374 6.997.258 1.752.467 3.831.622 6.18a2.608 2.608 0 0 1-.662 1.922m2.363-8.444c-.394-2.682-.985-5.393-1.412-7.196a4.947 4.947 0 0 0-4.532-3.82c-2.162-.135-5.74-.296-10.506-.296-4.765 0-8.343.161-10.505.296a4.947 4.947 0 0 0-4.532 3.82c-.427 1.802-1.018 4.513-1.413 7.196-.267 1.814-.483 3.956-.642 6.367A4.937 4.937 0 0 0 1.265 26.3a4.945 4.945 0 0 0 3.483 1.657c2.96.139 7.508.304 12.355.304 4.848 0 9.395-.165 12.356-.304a4.945 4.945 0 0 0 3.483-1.657 4.937 4.937 0 0 0 1.254-3.642c-.16-2.41-.375-4.553-.643-6.367"></path>
      </g>
    </Base>
  );
};

export default Logo;
